import React, { Component, Fragment } from 'react';
import { Label, Row, Col, Input, Table } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.css';
var moment = require('moment-business-days');

class CustomerWorkflowDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoaded: false,
            clientId: parseInt(this.props.selector) > 0 ? this.props.selector : 0,
            data: [],
            sheetData: [],
            clientList: this.props.filterClients()
        };

        this.headersDaily = ['Workflow Step', 'Workflow Name', 'Workflow Description', 'Start Time (EST)', 'End Time (EST)', 'Task Duration'];
        this.headersMonthly = ['Workflow Step', 'Workflow Description', 'Due Date', 'Completed', 'Diff', 'Start Time (EST)', 'End Time (EST)', 'Task Duration'];
    }

    componentDidMount() {
        this.props.log('CustomerWorkflowDetail.js/componentDidMount');
        if (this.state.clientId > 0) this.onSubmit();
        this.props.filterClientsCallback(() => {
            this.setState({
                clientList: this.props.filterClients()
            })
        });
    }

    getDuration = (num) => {
        this.props.info('CustomerWorkflowDetail.js/getDuration (num)', num);
        switch (parseInt(num)) {
            case 24:
                return "(Daily)";
            case 730:
                return "(Monthly)";
            case 2190:
                return "(Quarterly)";
            case 8760:
                return "(Annually)";
            default:
                return "";
        }
    }

    formatAMPM = (date) => {
        this.props.info('CustomerWorkflowDetail.js/formatAMPM (date)', date);
        if (date === '' || date == null) return date;
        var [hours, minutes] = date.split(':').map(item => parseInt(item));
        var ampm = hours >= 12 ? 'pm' : 'am';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? '0' + minutes : minutes;
        var strTime = hours + ':' + minutes + ' ' + ampm;
        return strTime;
    }

    onSubmit = () => {
        this.props.log('CustomerWorkflowDetail.js/onSubmit');
        fetch('/api/reports/CustomerWorkflowDetail', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            },
            body: JSON.stringify([
                { key: 'clientId', type: 'int', value: this.state.clientId }
            ])
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({
                        isLoaded: true,
                        data: results.data
                    }, () => this.getCSVdata());
                } else {
                    this.props.addToast('Unable to download report.', 5, 'danger');
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    getCSVdata = () => {
        this.props.log('CustomerWorkflowDetail.js/getCSVdata');
        let retArr = [];
        if (parseInt(this.state.clientId) > 0) {
            this.state.data.forEach(table => {
                retArr.push([table.workflowName + ' ' + this.getDuration(table.workflowDuration), '', '', '', '', '']);
                retArr.push(['', '', '', '', '', '']);
                retArr.push(table.workflowDuration === 24 ? this.headersDaily.map(header => header) : this.headersMonthly.map(header => header));
                if (table.workflowDuration === 24 && table.timeTracking != null) {
                    table.timeTracking.filter(row => row.workflowTasks != null).forEach(row => {
                        retArr.push([row.workflowTasks[0].name, table.workflowName, table.workflowDescription,
                        ((row.beginTimestampAdjusted != null && row.beginTimestampAdjusted !== row.beginTimestamp) ? this.formatAMPM(row.beginTimestampAdjusted) + ' (' + this.formatAMPM(row.beginTimestamp) + ' ' + row.timezone.replace(/[^A-Z]/g, '') + ')' : this.formatAMPM(row.beginTimestamp)),
                        ((row.endTimestampAdjusted != null && row.endTimestampAdjusted !== row.endTimestamp) ? this.formatAMPM(row.endTimestampAdjusted) + ' (' + this.formatAMPM(row.endTimestamp) + ' ' + row.timezone.replace(/[^A-Z]/g, '') + ')' : this.formatAMPM(row.endTimestamp)),
                        (row.duration != null && row.duration !== '' ? row.duration + 'h' : '')]);
                    })
                } else if (table.timeTracking != null) {
                    table.timeTracking.filter(row => row.xworkflowTasks != null).forEach(row => {
                        const completionBusinessDays = row.workflowTasks[0].completionBusinessDays != null && row.workflowTasks[0].completionBusinessDays > 0 ? (row.workflowTasks[0].completionBusinessDays - 1) : 0;
                        const dueDate = moment(this.firstOfMonth(row.date), 'DD-MM-YYYY').businessAdd(completionBusinessDays)._d;
                        retArr.push([row.workflowTasks[0].name, table.workflowDescription, this.displayDate(dueDate) + ' (' + row.workflowTasks[0].completionBusinessDays + 'd)',
                        this.displayDate(row.date), moment(new Date(row.date), 'MM-DD-YYYY').businessDiff(moment(dueDate), 'MM-DD-YYYY') + 'd',
                        ((row.beginTimestampAdjusted != null && row.beginTimestampAdjusted !== row.beginTimestamp) ? this.formatAMPM(row.beginTimestampAdjusted) + ' (' + this.formatAMPM(row.beginTimestamp) + ' ' + row.timezone.replace(/[^A-Z]/g, '') + ')' : this.formatAMPM(row.beginTimestamp)),
                        ((row.endTimestampAdjusted != null && row.endTimestampAdjusted !== row.endTimestamp) ? this.formatAMPM(row.endTimestampAdjusted) + ' (' + this.formatAMPM(row.endTimestamp) + ' ' + row.timezone.replace(/[^A-Z]/g, '') + ')' : this.formatAMPM(row.endTimestamp)),
                        (row.duration != null && row.duration !== '' ? row.duration + 'h' : '')]);
                    })
                }
                retArr.push(['', '', '', '', '', '']);
                if (table.workflowDuration === 24) {
                    retArr.push(['Total Tasks', '', '', (table.stats[0].min != null ? 'Earliest' : ''), (table.stats[0].max != null ? 'Latest' : ''), 'Total']);
                    retArr.push([table.stats[0].count, '', '',
                    ((table.stats[0].minAdjusted != null && table.stats[0].minAdjusted !== table.stats[0].min) ? this.formatAMPM(table.stats[0].minAdjusted) + ' (' + this.formatAMPM(table.stats[0].min) + ' ' + table.stats[0].timezone.replace(/[^A-Z]/g, '') + ')' : this.formatAMPM(table.stats[0].min)),
                    ((table.stats[0].maxAdjusted != null && table.stats[0].maxAdjusted !== table.stats[0].max) ? this.formatAMPM(table.stats[0].maxAdjusted) + ' (' + this.formatAMPM(table.stats[0].max) + ' ' + table.stats[0].timezone.replace(/[^A-Z]/g, '') + ')' : this.formatAMPM(table.stats[0].max)),
                    (table.stats[0].total != null && table.stats[0].total !== '' ? table.stats[0].total + 'h' : '')]);
                } else {
                    retArr.push(['Total Tasks', '', '', '', '', (table.stats[0].min != null ? 'Earliest' : ''), (table.stats[0].max != null ? 'Latest' : ''), 'Total']);
                    retArr.push([table.stats[0].count, '', '', '', '', 
                    ((table.stats[0].minAdjusted != null && table.stats[0].minAdjusted !== table.stats[0].min) ? this.formatAMPM(table.stats[0].minAdjusted) + ' (' + this.formatAMPM(table.stats[0].min) + ' ' + table.stats[0].timezone.replace(/[^A-Z]/g, '') + ')' : this.formatAMPM(table.stats[0].min)),
                    ((table.stats[0].maxAdjusted != null && table.stats[0].maxAdjusted !== table.stats[0].max) ? this.formatAMPM(table.stats[0].maxAdjusted) + ' (' + this.formatAMPM(table.stats[0].max) + ' ' + table.stats[0].timezone.replace(/[^A-Z]/g, '') + ')' : this.formatAMPM(table.stats[0].max)),
                    (table.stats[0].total != null && table.stats[0].total !== '' ? table.stats[0].total + 'h' : '')]);
                }
                retArr.push(['', '', '', '', '', '']);
                retArr.push(['', '', '', '', '', '']);
            });
            // console.log(retArr);
            this.props.passData(retArr, "customer-workflow-detail_" + (this.props.clients.filter(client => client.id === parseInt(this.state.clientId))[0].client).replaceAll(' ', '-'));
        }
    }

    onChange = (e) => {
        this.props.log('CustomerWorkflowDetail.js/onChange (name, value, e)', e.target.name, e.target.value, e);
        e.persist();
        this.props.changeSelector(e);
        this.setState({ clientId: e.target.value }, () => this.onSubmit())
    }

    displayDate = (date) => {
        this.props.info('CustomerWorkflowDetail.js/displayDate (date)', date);
        let d = new Date(date);
        return (d.getMonth() + 1) + '/' + d.getDate() + '/' + String(d.getFullYear()).substr(2, 2)
    }

    firstOfMonth = (date) => {
        this.props.log('CustomerWorkflowDetail.js/firstOfMonth (date)', date);
        let d = new Date(date);
        return new Date(d.getFullYear(), d.getMonth(), 1);
    }

    formatDiff = (num) => {
        this.props.log('CustomerWorkflowDetail.js/formatDiff (num)', num);
        return (num > 0) ? <span className="overdue">{num}d</span> : <span className="early">{num}d</span>
    }

    render() {
        this.props.info('CustomerWorkflowDetail.js/render');
        return (
            <><Row className="mb-4">
                <Col md={12} className="px-1 noPrint">
                    <Label>Company
                        <Input type="select" className="companySelect" name="clientId" value={this.props.isFieldNull(this.state.clientId)} onChange={(e) => this.onChange(e)}>
                            <option value="0">Select</option>
                            {this.state.clientList.filter(client => client.active).map(client => (
                                <option key={client.id} value={this.props.isFieldNull(client.id)}>{client.client}</option>
                            ))}
                        </Input>
                    </Label>
                </Col>
            </Row>
                {this.state.data.length > 0 ?
                    <>{this.state.data.map((table, tableIndex) => (
                        <Fragment key={tableIndex}>
                            <h3>{table.workflowName} {this.getDuration(table.workflowDuration)}</h3>
                            <Table className="mb-5">
                                <thead>
                                    <tr>
                                        {table.workflowDuration === 24 ? this.headersDaily.map((header, headerIndex) => (
                                            <th key={headerIndex}>{header}</th>
                                        )) : this.headersMonthly.map((header, headerIndex) => (
                                            <th key={headerIndex}>{header}</th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {table.timeTracking != null && table.timeTracking.filter(row => row.workflowTasks != null).map((row, rowIndex) => {
                                        const completionBusinessDays = row.workflowTasks[0].completionBusinessDays != null && row.workflowTasks[0].completionBusinessDays > 0 ? (row.workflowTasks[0].completionBusinessDays - 1) : 0;
                                        const dueDate = moment(this.firstOfMonth(row.date), 'DD-MM-YYYY').businessAdd(completionBusinessDays)._d;
                                        return (
                                            table.workflowDuration === 24 ?
                                                <tr key={rowIndex}>
                                                    <td>{row.workflowTasks[0].name}</td>
                                                    <td>{table.workflowName}</td>
                                                    <td>{table.workflowDescription}</td>
                                                    <td>{row.beginTimestampAdjusted != null && row.beginTimestampAdjusted !== row.beginTimestamp ? <>{this.formatAMPM(row.beginTimestampAdjusted)} <span className='text-muted font-italic'>{' (' + this.formatAMPM(row.beginTimestamp) + ' ' + row.timezone.replace(/[^A-Z]/g, '') + ')'}</span></> : this.formatAMPM(row.beginTimestamp)}</td>
                                                    <td>{row.endTimestampAdjusted != null && row.endTimestampAdjusted !== row.endTimestamp ? <>{this.formatAMPM(row.endTimestampAdjusted)} <span className='text-muted font-italic'>{' (' + this.formatAMPM(row.endTimestamp) + ' ' + row.timezone.replace(/[^A-Z]/g, '') + ')'}</span></> : this.formatAMPM(row.endTimestamp)}</td>
                                                    <td>{row.duration != null && row.duration !== '' ? row.duration + 'h' : ''}</td>
                                                </tr> :
                                                <tr key={rowIndex}>
                                                    <td>{row.workflowTasks[0].name}</td>
                                                    <td>{table.workflowDescription}</td>
                                                    <td><span className="timerLine">{this.displayDate(dueDate)} ({row.workflowTasks[0].completionBusinessDays}d)</span></td>
                                                    <td>{this.displayDate(row.date)}</td>
                                                    <td>{this.formatDiff(moment(new Date(row.date), 'MM-DD-YYYY').businessDiff(moment(dueDate), 'MM-DD-YYYY'))}</td>
                                                    <td>{this.formatAMPM(row.beginTimestamp)}</td>
                                                    <td>{this.formatAMPM(row.endTimestamp)}</td>
                                                    <td>{row.duration != null && row.duration !== '' ? row.duration + 'h' : ''}</td>
                                                </tr>
                                        )
                                    })}
                                </tbody>
                                <tfoot className="inactiveTab">
                                    <tr>
                                        <th colSpan={table.workflowDuration === 24 ? 3 : 5}>Total Tasks</th>
                                        {table.stats[0].min != null ? <th>Earliest</th> : <th></th>}
                                        {table.stats[0].max != null ? <th>Latest</th> : <th></th>}
                                        <th>Total</th>
                                    </tr>
                                    <tr>
                                        <td colSpan={table.workflowDuration === 24 ? 3 : 5}>{table.stats[0].count}</td>
                                        <td>{table.stats[0].minAdjusted != null && table.stats[0].minAdjusted !== table.stats[0].min ? <>{this.formatAMPM(table.stats[0].minAdjusted)} <span className='text-muted font-italic'>{' (' + this.formatAMPM(table.stats[0].min) + ' ' + table.stats[0].timezone.replace(/[^A-Z]/g, '') + ')'}</span></> : this.formatAMPM(table.stats[0].min)}</td>
                                        <td>{table.stats[0].maxAdjusted != null && table.stats[0].maxAdjusted !== table.stats[0].max ? <>{this.formatAMPM(table.stats[0].maxAdjusted)} <span className='text-muted font-italic'>{' (' + this.formatAMPM(table.stats[0].max) + ' ' + table.stats[0].timezone.replace(/[^A-Z]/g, '') + ')'}</span></> : this.formatAMPM(table.stats[0].max)}</td>
                                        <td>{table.stats[0].total != null && table.stats[0].total !== '' ? table.stats[0].total + 'h' : ''}</td>
                                    </tr>
                                </tfoot>
                            </Table>
                        </Fragment>
                    ))}</>
                    : <>{this.state.isLoaded ? "No Results" : ""}</>}
            </>
        );
    }
}

export default CustomerWorkflowDetail;
